module.exports = __webpack_public_path__ + "img/official_account.6224f454.png";